import { RootAppState } from 'store/configureStore'

export const projectStatusChangeInPortalAllowedManuallySetSelector = (
  state: RootAppState,
) => {
  return state.project.activeProject?.statusChangeInPortalIsAllowedManuallySet
}
